import { Spinner } from 'reactstrap';

const LoadingOverlay = ({ show, children }) => (
    <div
        className="position-relative"
        aria-busy={show}
        aria-live="polite"
    >
        <div style={{ opacity: show ? 0.5 : 1, pointerEvents: show ? 'none' : 'auto' }}>
            {children}
        </div>
        {show && (
            <div
                className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
                style={{ top: 0, left: 0 }}
            >
                <Spinner />
            </div>
        )}
    </div>
);

export default LoadingOverlay;

